(() => {
  const globalKey = 'CyantHeaderCompactObserverInitialized';

  if (window[globalKey]) {
    window[globalKey].init(document);
    return;
  }

  const desktopMedia = window.matchMedia('(min-width: 990px)');
  const records = new Map();
  let mediaListenerAttached = false;

  const updateClass = (section, masthead) => {
    const mastheadPassed = masthead.getBoundingClientRect().bottom <= 0;
    section.classList.toggle('cyant-compact-visible', mastheadPassed);
  };

  const configureRecord = (record) => {
    record.observer?.disconnect();
    record.observer = null;

    if (!desktopMedia.matches) {
      record.section.classList.remove('cyant-compact-visible');
      return;
    }

    updateClass(record.section, record.masthead);

    if (!('IntersectionObserver' in window)) return;

    record.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const mastheadPassed = entry.boundingClientRect.bottom <= 0;
          record.section.classList.toggle('cyant-compact-visible', mastheadPassed);
        });
      },
      { threshold: 0 }
    );
    record.observer.observe(record.masthead);
  };

  const handleBreakpointChange = () => {
    records.forEach(configureRecord);
  };

  const attachMediaListener = () => {
    if (mediaListenerAttached) return;

    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', handleBreakpointChange);
    } else {
      desktopMedia.addListener(handleBreakpointChange);
    }
    mediaListenerAttached = true;
  };

  const detachMediaListener = () => {
    if (!mediaListenerAttached) return;

    if (desktopMedia.removeEventListener) {
      desktopMedia.removeEventListener('change', handleBreakpointChange);
    } else {
      desktopMedia.removeListener(handleBreakpointChange);
    }
    mediaListenerAttached = false;
  };

  const initSection = (section) => {
    const masthead = section.querySelector('.cyant-header--home .header');
    if (!masthead) return;

    const existingRecord = records.get(section);
    existingRecord?.observer?.disconnect();

    const record = { section, masthead, observer: null };
    records.set(section, record);
    attachMediaListener();
    configureRecord(record);
  };

  const destroySection = (section) => {
    const record = records.get(section);
    if (!record) return;

    record.observer?.disconnect();
    section.classList.remove('cyant-compact-visible');
    records.delete(section);

    if (records.size === 0) detachMediaListener();
  };

  const init = (root = document) => {
    if (root instanceof Element && root.matches('.section-header')) initSection(root);
    root.querySelectorAll?.('.section-header').forEach(initSection);
  };

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    records.forEach((_record, section) => {
      if (section === event.target || event.target.contains(section)) destroySection(section);
    });
  });

  window[globalKey] = { init };
  init(document);
})();
